/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import { Chip } from '@mui/material';

const JanusPlayer = React.forwardRef(
  (
    {
      status,
      // onBandwidthChange,
    },
    ref,
  ) => {
    return (
      <div ref={ref} style={{ position: 'relative' }}>
        <video
          className="janus-video-player"
          autoPlay
          playsInline
          style={{
            background: 'black',
            filter: status === 'Paused' && 'blur(4px)',
          }}
        />
        <div
          className="janus-video-status"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
          }}
        >
          {status === 'Ready' && <Chip label="준비중" size="small" />}
          {status === 'Calling' && (
            <Chip label="거는중" size="small" color="secondary" />
          )}
          {status === 'Paused' && (
            <Chip label="대기중" size="small" variant="outlined" />
          )}
          {status === 'Live' && (
            <Chip label="통화중" size="small" color="success" />
          )}
          {status === 'Error' && (
            <Chip label="오류" size="small" color="error" />
          )}
          {status === 'End' && (
            <Chip label="종료" size="small" color="error" variant="outlined" />
          )}
        </div>
      </div>
    );
  },
);

export default JanusPlayer;
